import { useMemo } from "react";
import timezones from "@/lib/timezones.json";

// Bundled IANA names keep the picker available in browsers without
// Intl.supportedValuesOf. Preserve saved aliases and the browser's own zone.
export default function TimezoneSelect({ value, onChange, ...props }) {
  const options = useMemo(() => [...new Set(["UTC", ...timezones, value].filter(Boolean))].sort(), [value]);
  return <select {...props} value={value} onChange={onChange}>
    <option value="" disabled>Select a timezone</option>
    {options.map((zone) => <option key={zone} value={zone}>{zone.replaceAll("_", " ").replaceAll("/", " / ")}</option>)}
  </select>;
}
